import { render } from "./scrollDown.vue?vue&type=template&id=473633d0&scoped=true"
import script from "./scrollDown.vue?vue&type=script&lang=js"
export * from "./scrollDown.vue?vue&type=script&lang=js"

import "./scrollDown.vue?vue&type=style&index=0&id=473633d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473633d0"]])

export default __exports__